import type { App } from '../app/App';
import type { CosmeticDef } from '../game/data/cosmetics';
import { t } from '../i18n';
import { artImg } from './components';
import { h } from './dom';

/** Victory stamp: hand-drawn art when delivered, else the word in the stamp's ink. */
export function stampFace(app: App, def: CosmeticDef, cls: string): Node {
  return (
    artImg(app, def.id, `${cls} stamp-art`) ??
    h('span', { class: `${cls} stamp-text`, style: { '--stamp-ink': def.color } as unknown as Partial<CSSStyleDeclaration> }, t(def.text ?? def.name))
  );
}
